import ElementUI from "element-ui";
const { MessageBox, Message } = ElementUI;
import axios from "axios";

const tokenKey = "masterKey";

// 根据环境自动切换服务器地址
const AppURL = "http://app.hbgcjc.com"; //    "https://localhost:5001/api"; //  // http://api.zh.sanwo.tech/api
const ServerURL = "https://api.app.hbgcjc.com/api"; //    "https://localhost:5001/api"; //  // http://api.zh.sanwo.tech/api
const imgServerURL = "https://api.app.hbgcjc.com"; // ""; //  "https://localhost:44342"; //   http://api.zh.sanwo.tech
const MServerUrl = "http://m.app.hbgcjc.com"; // 手机端     http://m.zh.sanwo.tech

// const AppURL = "http://zh.sanwo.tech"; //    "https://localhost:5001/api"; //  // http://api.zh.sanwo.tech/api
// const ServerURL = "http://api.zh.sanwo.tech/api";
// const imgServerURL = "http://api.zh.sanwo.tech";
// const MServerUrl = "http://m.zh.sanwo.tech";

function isDevelopment() {
    return process && process.env && process.env.NODE_ENV == "development";
}


// loading
function showLoading() {
    window._loading(true);
}

function hideLoading() {
    window._loading(false);
}

// token
function getToken() {
    // console.log(localStorage.getItem(tokenKey),'token');
    return localStorage.getItem(tokenKey);
}

function setToken(token) {
    localStorage.setItem(tokenKey, token);
}

// 提示
function error(err) {
    return MessageBox.alert(err, {
        type: "error",
        // center: true
    });
}

function success(msg) { 
    return Message({ message: msg, type: "success", duration: 1000 });
}

function confirm(content, title = "确认操作") {
    return MessageBox.confirm(content, title, {
        type: "warning",
        center: true,
        dangerouslyUseHTMLString: true,
    });
}


function sleep(ms) {
    return new Promise((resolve) => {
        let tt = setTimeout(() => {
            resolve();
            clearTimeout(tt);
        }, ms);
    });
}

// 全屏
function fullScreen() {
    //返回文档的 documentElement:
    let element = document.documentElement;
    if (element.requestFullscreen) {
        // 用于发出异步请求使元素进入全屏模式
        element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
}

function exitFullscreen() {
    // 方法用于让当前文档退出全屏模式
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
}

function isFullScreen() {
    // !! 相当于将非布尔类型直接转为布尔类型的值
    return !!(
        document.webkitIsFullScreen ||
        document.mozFullScreen ||
        document.msFullscreenElement ||
        document.fullscreenElement
    );
}

// 请求处理--对axios请求进行二次封装
const request = axios.create({
    // 远程服务器地址
    baseURL: ServerURL,
    // 超时
    timeout: 60 * 1000,
});

// 请求拦截
request.interceptors.request.use(
    (config) => {
        // 支持通过 config.noLoading = true 跳过全屏loading 
        if (config.method != "get" && !config.noLoading) {
            showLoading();
        }
        const token = getToken();
        if (token) {
            config.headers["token"] = token;
        }

        config.headers["Authorization"] = "Bearer " + token;

        var customerToken = localStorage.getItem("token_customer");
        if (customerToken) {
            config.headers["CSTID"] = customerToken;
        }


        return config;
    },
    (err) => {
        // 请求失败
        hideLoading();
        throw err;
    }
);

// 响应拦截器
request.interceptors.response.use(
    (response) => {
        const {
            method,
            responseType,
            url
        } = response.config;
        hideLoading();
        // 身份验证失败
        // 请求
        if (responseType === "blob") {
            if (response.status === 200) {
                return response;
            } else {
                let err = "请求文件出错 : 状态码错误!";
                error(err);
                throw err;
            }
        }
        // 正常的数据请求
        const {
            Code,
            Message,
            Detail,
            Data
        } = response.data;
        // console.log(
        //   `[${new Date().format(
        //     "hh:mm:ss"
        //   )}] ${method.toUpperCase()} ${url} 返回: [${code}] ${message}!`
        // );

        // 服务器端返回错误
        if (Code !== 100) {
            if(Detail){
                error(Detail);
            }else{
                error(Message);
            }
            throw error;
        }
        return Data;
    },
    (err) => {
        hideLoading();
        console.log(err,'访问401的路径');

        if (err.response.status == 401) {
            if (window.top)
                window.top.location = "/#/login";
            else location = "/#/login";
        }

        if (err.response.status == 404 || err.response.status == 500) {
            error("服务器繁忙 : " + err);
        }
        throw err;
    }
);

function mm2px(dpi, nm) {
    let ppi = (Number(dpi) || 96) / 25.4;
    return Math.ceil(nm * ppi) + "px";
}

function getMessager(id) {
    if (!window.top._CHICMessager) {
        window.top._CHICMessager = {};
    }
    let messager = window.top._CHICMessager;
    if (!messager[id]) {
        messager[id] = {
            do(sid, message) {},
        };
    }
    return messager[id];
}

function registMessage(id, cb) {
    getMessager(id).do = cb;
}

async function sendMessage(tid, message) {
    let messager = getMessager(tid);
    if (messager) {
        return await messager.do(sid, message);
    } else {
        return null;
    }
}

function downloadFile(url, filename) {
    return new Promise((resolve, reject) => {
        request
            .get(url, {
                responseType: "blob",
            })
            .then((response) => {
                if (response.data.size == 0) {
                    Message.error("下载失败: 服务器出错!");
                    return resolve();
                }
                resolve({
                    statusCode: 0,
                    statusString: "",
                });
                // ie使用的下载方式
                if ("msSaveOrOpenBlob" in navigator) {
                    window.navigator.msSaveOrOpenBlob(response.data, filename);
                    return;
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            });
    });
}

function uploadFile(file, type) {
    if (!file) {
        return;
    }
    const param = new FormData();
    param.append("file", file);
    const config = {
        headers: {
            "Content-Type": "multipart/form-data;charset=utf-8",
        },
    };
    const url = `/File/Upload`;
    return request.post(url, param, config);
}


function uploadFileBase64(file) {
    if (!file) {
        return;
    }
    const param = new FormData();
    param.append("file", file);
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    };
    const url = `/File/UploadBase64`;
    return request.post(url, param, config);
}

function getFile(file) {
    if (!file) {
        return;
    }
    return `${ServerURL}/file/getFile?url=${file}`;
}

function getUploadUrl() {
    return `${ServerURL}/File/Upload/`;
}

function dateDiffDaysForToday(sDate1) {
    var date2 = new Date();
    var date1 = new Date(Date.parse(sDate1.replace(/-/g, "/")));
    var iDays = parseInt((date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24);
    return iDays;
}



export default {
    request,
    isDevelopment,
    showLoading,
    hideLoading,
    getToken,
    setToken,
    error,
    success,
    confirm,
    sleep,
    fullScreen,
    exitFullscreen,
    isFullScreen,
    getUploadUrl,
    mm2px,
    registMessage,
    sendMessage,
    uploadFile,
    uploadFileBase64,
    downloadFile,
    getFile,
    AppURL,
    ServerURL,
    imgServerURL,
    MServerUrl,
    dateDiffDaysForToday
};